{
  "ascending": "возрастание",
  "ascendingSort": "сортировать столбец {columnName} в порядке возрастания",
  "descending": "убывание",
  "descendingSort": "сортировать столбец {columnName} в порядке убывания",
  "select": "Выбрать",
  "selectAll": "Выбрать все",
  "sortable": "сортируемый столбец"
}
